<template>
  <div>
    <template v-if="file || url">
      <with-error-message class="relative" :show-error="isFileUrlError">
        <div class="flex items-center gap-2 p-3 bg-soft border-solid rounded-lg border-gray-border mt-4">
          <img :src="file_icon" alt="file icon"/>
          {{ fileName }}
        </div>
      </with-error-message>
      <div class="flex flex-col items-center mt-10 gap-4">
        <base-button v-if="file && file.url"
                     variant="bordered"
                     class="w-full"
                     :external-link="file.url"
                     target="_blank"
        >
          View file
        </base-button>
        <base-button variant="bordered-error"
                     class="w-full"
                     @click.prevent="removeUrlFile"
        >
          Remove file
        </base-button>
      </div>
    </template>

    <template v-else>
      <base-label id="url" label="File URL" :label-classes="'font-medium'"/>
      <div class="flex items-center gap-2">
        <base-input name="url"
                    placeholder="e.g. https://www.website.com/your-file"
                    variant="editor"
                    type="string"
                    class="w-full border-gray-border py-px mt-1 h-10"
                    :value="url"
                    v-model="urlValue"
        />
        <busy-button
          id="upload-file"
          variant="bordered"
          :is-disabled="!urlValue || !isValidUrl"
          class="h-10 w-12 flex items-center mt-0.5"
          @click.prevent="updateUrl"
        >
          <upload-file-icon class="text-primary"/>
        </busy-button>
      </div>
      <whitelist-hint/>

      <p class="w-full text-center mt-5">OR</p>
      <div>
        <base-label id="file" label="File" :label-classes="'font-medium'"/>
        <base-file-input
          :value="file"
          class="mt-1"
          @input="updateFile"
        />
      </div>
    </template>
  </div>
</template>

<script>
import BaseInput from '@/components/base-components/BaseInput.vue'
import BaseLabel from '@/components/base-components/BaseLabel.vue'
import BaseFileInput from '@/components/base-components/BaseFileInput.vue'
import BaseButton from '@/components/base-components/BaseButton.vue'
import BusyButton from '@/components/common/BusyButton.vue'
import DeleteIcon from '@/assets/images/icons/DeleteIcon'
import UploadFileIcon from '@/assets/images/icons/UploadFileIcon.vue'
import file_icon from '@/assets/images/icons/file_icon.svg'
import previewModule from '@/store/modules/preview.module'
import { REGEXES } from '@/utils/key-regex.constants'
import WithErrorMessage from '@/components/common/WithErrorMessage.vue'
import WhitelistHint from '@/components/common/WhitelistHint.vue'

export default {
  name: 'SettingsIndexesFile',
  components: {
    DeleteIcon,
    UploadFileIcon,
    BusyButton,
    BaseButton,
    BaseFileInput,
    BaseLabel,
    BaseInput,
    WithErrorMessage,
    WhitelistHint
  },
  props: {
    file: File | Object,
    url: String
  },
  data() {
    return {
      file_icon,
      urlValue: this.url
    }
  },
  computed: {
    error: previewModule.error,
    errorDescription: previewModule.errorDescription,

    fileName() {
      return this.file ? this.file.name : this.url.split('/').pop()
    },
    isFileUrlError() {
      return this.errorDescription?.includes('URL') || this.errorDescription?.includes('File exceeds') || this.errorDescription?.includes('File mimeType') || this.error?.includes('Supported')
    },
    isValidUrl() {
      return this.urlValue ? REGEXES.VALID_URL.test(this.urlValue) : false
    }
  },
  methods: {
    getFileType: (url) => url.split('.').pop().toLowerCase(),
    updateUrl() {
      this.$emit('update:url', this.urlValue)
    },
    updateFile(newFile) {
      this.$emit('update:file', newFile)
    },
    removeUrlFile() {
      if (this.isFileUrlError) this.error = null
      this.$emit('reset:fileSettings')
    }
  },
  destroyed() {
    if (this.isFileUrlError) this.error = null
  }
}
</script>
